import { render, staticRenderFns } from "./ShowCustomContent.vue?vue&type=template&id=4d55b17c"
import script from "./ShowCustomContent.vue?vue&type=script&lang=js"
export * from "./ShowCustomContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports